import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RootController } from '../../../eye-test/controller/root.controller';
import '../../../result/views/go-back-buttons';
import './contact-button.scss';
import { postEnd } from '../../../result/util/axios';

library.add(faCalendarAlt);

export const ContactButton: React.FunctionComponent = () => {
	const handleClick = (): void => {
		const url = '/contactform.php?meta=' + encodeURIComponent('id=' + RootController.globalUserID);
		console.log('Redirect');
		console.log(encodeURIComponent('id=' + RootController.globalUserID));
		console.log('/Redirect');

		postEnd('contact',url);
	};

	return (
		<button tabIndex={0} className={'go-back__button contact-button'} onClick={handleClick}>
			<FontAwesomeIcon className={'contact-button__calendar-icon'} icon={'calendar-alt'}/>
			<span className={'contact-button__text'}>Termin vereinbaren</span>
		</button>
	);
};
